import { render, staticRenderFns } from "./BaiduCloud.vue?vue&type=template&id=5aeaf6b7"
import script from "./BaiduCloud.vue?vue&type=script&lang=js"
export * from "./BaiduCloud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports